export default __webpack_public_path__ + "static/10-61ddab7cda424a8646bf5f418d76adad.jpg";